import { ComponentRef, ViewContainerRef } from '@angular/core';
import { SecurityQuestionComponent } from './security-question.component';

export class SecurityQuestionFormSession {
  clientContext: any;
  viewContainerRef: ViewContainerRef;
  securityQuestionComponentRef: ComponentRef<SecurityQuestionComponent>;

  actionContext: any;
  submitHandler: any;
  mode: any;
  title: string;
  username: string;
  description: any;
  actionEscapeOption: any;


  constructor(title, username){

      this.title = title;
      this.username = username;
  }
  // this.submitHandler = null;

  startSession(
    description: com.ts.mobile.sdk.AuthenticatorDescription,
    mode: com.ts.mobile.sdk.AuthenticatorSessionMode,
    actionContext: com.ts.mobile.sdk.PolicyAction | null,
    clientContext: object | null
  ): void {

    this.actionContext = actionContext;
    this.clientContext = clientContext;
    this.mode = mode;

    this.description = description;
    this.actionEscapeOption = false;
  }

  endSession(): void {

  }

  promiseInput(): Promise<com.ts.mobile.sdk.InputOrControlResponse<ResponseType>>{
    this.viewContainerRef = (this.clientContext as any).viewContainerRef;
    this.viewContainerRef.clear();

    this.securityQuestionComponentRef = this.viewContainerRef.createComponent(SecurityQuestionComponent);

    this.securityQuestionComponentRef.instance.securityQuestion = this.actionContext.getUiContext().getString("question");
    this.securityQuestionComponentRef.instance.onSecurityAnwerSubmit = this.onSecurityQuestionSubmit.bind(this);
    this.securityQuestionComponentRef.instance.onCancelSubmit = this.onCancel.bind(this);

    return new Promise((resolve, reject) => {
      this.submitHandler = (response) => {
        resolve(response);
      };
    });
  }

  promiseRecoveryForError(
    error: com.ts.mobile.sdk.AuthenticationError,
    validRecoveries: Array<com.ts.mobile.sdk.AuthenticationErrorRecovery>,
    defaultRecovery: com.ts.mobile.sdk.AuthenticationErrorRecovery
  ): Promise<com.ts.mobile.sdk.AuthenticationErrorRecovery> {
    return new Promise((resolve, reject) => {

      const userId = this.clientContext['cookieService'].get('userEmail');

      if (error){
        const attemptsLeft = error.getData()?.['additional_data']?.['retries_left'];
        if (attemptsLeft > 0){
          setTimeout(() => this.securityQuestionComponentRef.instance.setErrorCode('invalid'), 100);
        }
    }
      resolve(defaultRecovery);
    });
  }

  private onSecurityQuestionSubmit(answer: string) {
    const inputResponse = com.ts.mobile.sdk.PlaceholderInputResponse.createSuccessResponse(answer);
    const response = com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(inputResponse);
    this.submitHandler(response);
  }

  private onCancel() {
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'cancel_forgotPassword';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=cancel_forgotPassword' 
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

}


export default SecurityQuestionFormSession;
